import { t, Trans } from '@lingui/macro';
import { NoddiButton } from 'noddi-ui-common';
import { ContentWrapper, FixedBottomBarContainer } from 'noddi-ui-web';
import { customerRoutes } from 'noddi-util';
import { useNavigate } from 'react-router-dom';
import { AddressPicker } from '../../../components/Address/AddressPicker';
import { useBookingProposalActions, useBookingProposalAddress, useBookingProposalSlug } from '../bookingProposalStore';

export const BookingProposalAddress = () => {
  const { setAddress, setBookingTimeWindow } = useBookingProposalActions();
  const address = useBookingProposalAddress();
  const navigate = useNavigate();
  const slug = useBookingProposalSlug();

  const handleNavigateNextStep = () => {
    navigate(customerRoutes.bookingProposalTimeWindowPicker.getPath({ slug }));
  };

  return (
    <ContentWrapper className='max-w-screen-md' title={t`Where do you need our help?`}>
      <AddressPicker
        setSelectedAddress={(address) => {
          setAddress(address);
          setBookingTimeWindow(undefined);
        }}
        selectedAddress={address}
      />
      <FixedBottomBarContainer>
        <div className='flex w-full justify-end'>
          <NoddiButton disabled={!address} endIcon='ArrowRight' onPress={handleNavigateNextStep}>
            <Trans>Next</Trans>
          </NoddiButton>
        </div>
      </FixedBottomBarContainer>
    </ContentWrapper>
  );
};
